__turbopack_context__.v({
  "slide": "Slider-module-scss-module__3HSeJG__slide",
  "slideWrapper": "Slider-module-scss-module__3HSeJG__slideWrapper",
});
